import categoryGroups from 'data/categoryGroups';

export const handlePageChange = (reduxAction) => () => {
  reduxAction();
  // const el = document.getElementById("form-top");
  // if (el.scrollIntoView) el.scrollIntoView();
};

export const categoryOptions = [].concat(
  ...categoryGroups.map((group) => group.categoryOptions)
);

export const accessTokenFromUrl = () => {
  const match = window.location.href.match(/affiliate-contact\/(\w{24})/);
  return match ? match[1] : '';
};
